import React from "react";

const Image = () => (
  <svg width="65" height="65" viewBox="0 0 65 65">
    <path
      d="M62 32.5a29.5 29.5 0 1 1-59 0 29.5 29.5 0 0 1 59 0z"
      stroke="#DADADA"
      strokeWidth="3"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);
export default Image;
